import { useEffect, useState } from "react";
import { api } from "../lib/utils";

export const useGetAllCategories = (department) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (department) {
      getAllCategoriesDepartmentWise();
    }
  }, [department]);

  const getAllCategoriesDepartmentWise = async () => {
    try {
      const encodedDepartment = encodeURIComponent(department);
      const result = await api.get(
        `/api/categories/getCategoriesDepartmentwise?department=${encodedDepartment}`,
      );
      if (result) {
        setCategories(result?.data);
      }
    } catch (err) {
      return err;
    }
  };

  return categories;
};
